import React, { useState, useEffect } from 'react';
import { Button, Modal, Input, message, TreeSelect } from 'antd';
import { getAreas, getTemaArea, getNivelConsulta, insertIndicador } from '../../services/areaService';
import ModalCreateTema from './createTema';

const ModalCreate = ({ onCreate }) => {
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [treeData, setTreeData] = useState([]);
    const [treeDatatema, setTreeDatatema] = useState([]);
    const [treeDataNivelConsulta, setTreeDataNivelConsulta] = useState([]);
    const [valueArea, setValueArea] = useState();
    const [valueTema, setValueTema] = useState();
    const [descripcion, setDescripcion] = useState('');
    const [codigoIndicador, setCodigoIndicador] = useState('');
    const [nivelConsulta, setNivelConsulta] = useState('');

    useEffect(() => {
        fetchAreas();
        fetchNivelConsulta();
    }, []);

    const fetchAreas = async () => {
        setLoading(true);
        try {
            const response = await getAreas();
            if (Array.isArray(response)) {
                const AreasData = response.map((area) => ({
                    title: area.descripcion,
                    key: area.id,
                    value: area.id,
                }));
                setTreeData(AreasData);
            } else {
                message.error('Los datos no se han podido obtener.');
            }
        } catch (error) {
            console.log(error);
            message.error('Error al obtener los datos de las áreas.');
        } finally {
            setLoading(false);
        }
    };

    const fetchNivelConsulta = async () => {
        setLoading(true);
        try {
            const response = await getNivelConsulta();
            if (response.status === 200) {
                const NivelesData = response.data.map((nivel) => ({
                    title: nivel.nombre,
                    key: nivel.id,
                    value: nivel.id,
                }));
                setTreeDataNivelConsulta(NivelesData);
            } else {
                console.log(response);
                message.error('Los datos no se han podido obtener.');
            }
        } catch (error) {
            // console.log(error);
            message.error('Error al obtener los niveles de consulta.');
        } finally {
            setLoading(false);
        }
    };

    const onChangeArea = async (newValue) => {
        setValueArea(newValue);
        try {
            const response = await getTemaArea(newValue);
            if (response.status === 200) {
                const TemasData = response.data.map((tema) => ({
                    title: tema.label,
                    key: tema.id,
                    value: tema.id,
                })).sort((a, b) => a.title.localeCompare(b.title));
                setTreeDatatema(TemasData);
            } else {
                message.error('Los datos no se han podido obtener.');
            }
        } catch (error) {
            console.error('Error al obtener los temas del área:', error);
            message.error('Error al obtener los temas del área.');
        }
    };

    const onChangeTema = (newValue) => {
        setValueTema(newValue);
    };

    const onChangeNivelConsulta = (newValue) => {
        setNivelConsulta(newValue);
    };

    const handleOk = async () => {
        setLoading(true);
        try {
            const indicadorData = {
                descripcion,
                codigoIndicador,
                nivelConsulta,
                oidTemaarea: valueTema,
            };
            const response = await insertIndicador(indicadorData);
            
            if (response.status === 200) {
                message.success('Indicador ingresado correctamente.');
                setOpen(false);
                onCreate();
                setDescripcion('');
                setCodigoIndicador('');
                setNivelConsulta('');
                setValueArea(null);
                setValueTema(null);
            } else {
                message.error('Los datos no se han podido obtener.');
            }
        } catch (error) {
            message.error('Error al insertar el indicador.');
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setOpen(false);
        setValueArea(null);
        setValueTema(null);
        setTreeDatatema([]);
    };

    const handleTemaCreated = async () => {
        if (valueArea) {
            await onChangeArea(valueArea);
        }
    };

    return (
        <>
            <Button type="primary" onClick={() => setOpen(true)}>
                Crear Indicador     
            </Button>
            <Modal
                open={open}
                title="Crear Indicador"
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[
                    <Button key="back" onClick={handleCancel}>
                        Cancelar
                    </Button>,
                    <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
                        Crear
                    </Button>,
                ]}
            >
                <span style={{ display: 'block', textAlign: 'center', marginBottom: 5 }}>Nombre <span style={{ color: 'red' }}>*</span></span>
                <Input
                    placeholder="Nombre Indicador"
                    value={descripcion}
                    onChange={(e) => setDescripcion(e.target.value)}
                    style={{ marginBottom: 10 }}
                />

                <span style={{ display: 'block', textAlign: 'center', marginBottom: 5 }}>Código del Indicador <span style={{ color: 'red' }}>*</span></span>
                <Input
                    placeholder="Código del Indicador"
                    value={codigoIndicador}
                    onChange={(e) => setCodigoIndicador(e.target.value)}
                    style={{ marginBottom: 10 }}
                />

                <span style={{ display: 'block', textAlign: 'center', marginBottom: 5 }}>Nivel de Consulta <span style={{ color: 'red' }}>*</span></span>
                <TreeSelect
                    placeholder="Selecciona el Nivel de Consulta"
                    showSearch
                    style={{ width: '100%', marginBottom: 10 }}
                    value={nivelConsulta || null}
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    allowClear
                    treeDefaultExpandAll
                    onChange={onChangeNivelConsulta}
                    treeData={treeDataNivelConsulta}
                />

                <span style={{ display: 'block', textAlign: 'center', marginBottom: 5 }}>Área <span style={{ color: 'red' }}>*</span></span>
                <TreeSelect
                    showSearch
                    style={{ width: '100%', marginBottom: 10 }}
                    value={valueArea}
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    placeholder="Selecciona un Área"
                    allowClear
                    treeDefaultExpandAll
                    onChange={onChangeArea}
                    treeData={treeData}
                />

                <span style={{ display: 'block', textAlign: 'center', marginBottom: 5 }}>
                    Tema <span style={{ color: 'red' }}>*</span>
                </span>
                <div className="tema">
                    <TreeSelect
                        showSearch
                        style={{ width: '100%', marginBottom: 10 }}
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder="Selecciona un Tema"
                        allowClear
                        treeDefaultExpandAll
                        onChange={onChangeTema}
                        treeData={treeDatatema}
                    />
                    <ModalCreateTema onTemaCreated={handleTemaCreated} />
                </div>
            </Modal>
        </>
    );
};

export default ModalCreate;
